import { CommentaryList } from './CommentaryList';
import { CommentaryEdit } from './CommentaryEdit';
import { CommentaryCreate } from './CommentaryCreate';

export default {
    list: CommentaryList,
    create: CommentaryCreate,
    edit: CommentaryEdit,
}